import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "antd";
import { ClientPricelist } from "@/root/models/pricelist";
import CreateClientPricelistModal from "./CreateClientPricelistModal";

interface CreatePricelistProps {
  onCreate: (pricelist: ClientPricelist) => void;
}

const CreatePricelist = ({ onCreate }: CreatePricelistProps) => {
  const [modal, setModal] = useState(false);
  const { t } = useTranslation();

  return (
    <div>
      <Button onClick={() => setModal(true)}>{t("Створити прайс лист")}</Button>
      <CreateClientPricelistModal
        open={modal}
        onCancel={() => setModal(false)}
        onCreate={onCreate}
      />
    </div>
  );
};

export default CreatePricelist;
